const TERMINAL_STATUSES = new Set(['pass', 'fail', 'blocked', 'skipped']);
const FAIL_SEVERITIES = new Set(['critical', 'major', 'minor', 'cosmetic']);

function guide(id, fileName, title, cardIds = [], acknowledgementIds = []) {
  return Object.freeze({
    id,
    revision: '2026-07-24',
    fileName,
    title,
    cardIds: Object.freeze(cardIds),
    acknowledgementIds: Object.freeze(acknowledgementIds),
  });
}

export const PM_GUIDE_MANIFEST = Object.freeze([
  guide('00', 'pm-guide-00-read-this-first.html', 'Read this first', [], [
    'ack-status-rules', 'ack-staged', 'ack-stateful', 'ack-evidence', 'ack-no-workaround',
  ]),
  guide('01', 'pm-guide-01-getting-in.html', 'Getting in and finding your way', [
    'TC-PMG1-SIGNIN-001', 'TC-PMG1-SIGNIN-002', 'TC-PMG1-WELCOME-001',
    'TC-PMG1-WELCOME-002', 'TC-PMG1-WELCOME-003', 'TC-PMG1-NAV-001',
    'TC-PMG1-NAV-002', 'TC-PMG1-NAV-003', 'TC-PMG1-NAV-004', 'TC-PMG1-FIND-001',
    'TC-PMG1-FIND-002', 'TC-PMG1-INBOX-001', 'TC-PMG1-FEEDBACK-001',
    'TC-PMG1-HELP-001', 'TC-PMG1-HELP-002', 'TC-PMG1-HELP-003', 'TC-PMG1-HELP-004',
  ]),
  guide('02', 'pm-guide-02-intake-scoring.html', 'Intake: submit and score a request', [
    'TC-PMG2-INTAKE-001', 'TC-PMG2-INTAKE-002', 'TC-PMG2-INTAKE-003',
    'TC-PMG2-REQUEST-001', 'TC-PMG2-REQUEST-002', 'TC-PMG2-REQUEST-003',
    'TC-PMG2-SCORE-001', 'TC-PMG2-SCORE-002', 'TC-PMG2-SCORE-003',
    'TC-PMG2-APPROVE-001', 'TC-PMG2-APPROVE-002',
  ]),
  guide('03', 'pm-guide-03-request-to-project.html', 'From request to governed project', [
    'TC-PMG3-START-001', 'TC-PMG3-FACTORY-001', 'TC-PMG3-FACTORY-002',
    'TC-PMG3-FACTORY-003', 'TC-PMG3-FACTORY-004', 'TC-PMG3-PLACEMAT-001',
    'TC-PMG3-PLACEMAT-002', 'TC-PMG3-PLACEMAT-003', 'TC-PMG3-CLOSEOUT-001',
    'TC-PMG3-CLOSEOUT-002', 'TC-PMG3-CLOSEOUT-003', 'TC-PMG3-KNOWLEDGE-001',
  ]),
  guide('04', 'pm-guide-04-lifecycle-risks-actions.html', 'Running the project: lifecycle, risks, and actions', [
    'TC-PMG4-LIFECYCLE-001', 'TC-PMG4-LIFECYCLE-002', 'TC-PMG4-LIFECYCLE-003',
    'TC-PMG4-GATE-001', 'TC-PMG4-ROLES-001', 'TC-PMG4-RISKS-001',
    'TC-PMG4-RISKS-002', 'TC-PMG4-RISKS-003', 'TC-PMG4-RISKS-004',
    'TC-PMG4-QUEUE-001', 'TC-PMG4-QUEUE-002', 'TC-PMG4-QUEUE-003', 'TC-PMG4-TIME-001',
  ]),
  guide('05', 'pm-guide-05-portfolio-leadership-views.html', 'Portfolio and leadership views', [
    'TC-PMG5-BOARD-001', 'TC-PMG5-BOARD-002', 'TC-PMG5-BOARD-003',
    'TC-PMG5-BOARD-004', 'TC-PMG5-PORTFOLIO-001', 'TC-PMG5-MONEY-001',
    'TC-PMG5-MONEY-002', 'TC-PMG5-DECISION-001', 'TC-PMG5-DECISION-002',
    'TC-PMG5-DECISION-003', 'TC-PMG5-DECISION-004', 'TC-PMG5-ROOM-001', 'TC-PMG5-ROOM-002',
  ]),
  guide('06', 'pm-guide-06-data-trust.html', 'Data you can trust: ingestion to lineage', [
    'TC-PMG6-DOOR-001', 'TC-PMG6-DOOR-002', 'TC-PMG6-TRUST-001', 'TC-PMG6-STAGE-001',
    'TC-PMG6-STAGE-002', 'TC-PMG6-VALIDATE-001', 'TC-PMG6-STAGE-003',
    'TC-PMG6-STAGE-004', 'TC-PMG6-LINEAGE-001', 'TC-PMG6-LINEAGE-002',
    'TC-PMG6-LINEAGE-003', 'TC-PMG6-ROLE-001', 'TC-PMG6-ROLE-002',
  ]),
  guide('07', 'pm-guide-07-ai-briefings.html', 'AI insights and briefing products', [
    'TC-PMG7-ASK-001', 'TC-PMG7-ASK-002', 'TC-PMG7-ASK-003', 'TC-PMG7-SIGNAL-001',
    'TC-PMG7-SIGNAL-002', 'TC-PMG7-SIGNAL-003', 'TC-PMG7-DECK-001', 'TC-PMG7-DECK-002',
    'TC-PMG7-DECK-003', 'TC-PMG7-EXPORT-001', 'TC-PMG7-DECK-004', 'TC-PMG7-BOUNDARY-001',
  ]),
  guide('08', 'pm-guide-08-access-feedback-adoption.html', 'Access, feedback, and adoption', [
    'TC-PMG8-EARN-001', 'TC-PMG8-EARN-002', 'TC-PMG8-EARN-003', 'TC-PMG8-EARN-004',
    'TC-PMG8-APPROVE-001', 'TC-PMG8-APPROVE-002', 'TC-PMG8-APPROVE-003',
    'TC-PMG8-FEEDBACK-001', 'TC-PMG8-FEEDBACK-002A', 'TC-PMG8-FEEDBACK-002B',
    'TC-PMG8-FEEDBACK-003A', 'TC-PMG8-DICTATION-001', 'TC-PMG8-ADOPT-001', 'TC-PMG8-ADOPT-002',
  ]),
  guide('09', 'pm-guide-09-rapid-events.html', 'RAPID events: six weeks from go to graduation', [
    'TC-PMG9-CC-001', 'TC-PMG9-CC-002', 'TC-PMG9-QUAL-001', 'TC-PMG9-QUAL-002',
    'TC-PMG9-QUAL-003', 'TC-PMG9-RUN-001', 'TC-PMG9-RUN-002', 'TC-PMG9-RUN-003',
    'TC-PMG9-RUN-004', 'TC-PMG9-LAND-001', 'TC-PMG9-LAND-002',
  ]),
  guide('10', 'pm-guide-10-persona-capstone.html', 'Capstone: one record, three pairs of eyes', [
    'TC-PMG10-PM-001', 'TC-PMG10-EXEC-001', 'TC-PMG10-EXEC-002',
    'TC-PMG10-STEW-001', 'TC-PMG10-STEW-002', 'TC-PMG10-HOME-001',
  ]),
  guide('11', 'pm-guide-11-give-feedback.html', 'Give feedback: from screenshot to fixed', [
    'TC-PMG11-CAPTURE-001', 'TC-PMG11-CAPTURE-002', 'TC-PMG11-CAPTURE-003',
    'TC-PMG11-CAPTURE-004', 'TC-PMG11-CAPTURE-005', 'TC-PMG11-TOOLS-001',
    'TC-PMG11-TOOLS-002', 'TC-PMG11-TOOLS-003', 'TC-PMG11-TOOLS-004',
    'TC-PMG11-NOTES-001', 'TC-PMG11-DICTATE-001', 'TC-PMG11-DRAFT-001',
    'TC-PMG11-DRAFT-002', 'TC-PMG11-DRAFT-003', 'TC-PMG11-DRAFT-004',
    'TC-PMG11-REVIEW-001', 'TC-PMG11-REVIEW-002', 'TC-PMG11-SUBMIT-001',
    'TC-PMG11-REPLAY-001', 'TC-PMG11-EXPORT-001', 'TC-PMG11-TRACK-001',
    'TC-PMG11-TRACK-002', 'TC-PMG11-QUEUE-001', 'TC-PMG11-TRIAGE-001',
    'TC-PMG11-INFO-001', 'TC-PMG11-CONVERT-001', 'TC-PMG11-RESOLVE-001',
  ]),
  guide('12', 'pm-guide-12-personalize-prime.html', 'Personalize PRIME: navigation, profile, and activity', [
    'TC-PMG12-NAV-001', 'TC-PMG12-NAV-002', 'TC-PMG12-NAV-003', 'TC-PMG12-NAV-004',
    'TC-PMG12-NAV-005', 'TC-PMG12-NAV-006', 'TC-PMG12-NAV-007', 'TC-PMG12-NAV-008',
    'TC-PMG12-NAV-009', 'TC-PMG12-NAV-010', 'TC-PMG12-NAV-011', 'TC-PMG12-NAV-012',
    'TC-PMG12-PROFILE-001', 'TC-PMG12-PROFILE-002', 'TC-PMG12-PROFILE-003',
    'TC-PMG12-ACTIVITY-001', 'TC-PMG12-ACTIVITY-002', 'TC-PMG12-ACTIVITY-003',
    'TC-PMG12-SEARCH-001', 'TC-PMG12-SHELL-001', 'TC-PMG12-SHELL-002',
    'TC-PMG12-MOBILE-001', 'TC-PMG12-MOBILE-002', 'TC-PMG12-MOBILE-003',
  ]),
]);

export const PM_GUIDE_BY_ID = Object.freeze(
  Object.fromEntries(PM_GUIDE_MANIFEST.map((entry) => [entry.id, entry])),
);

export function normalizePmGuideState(state = {}) {
  const cases = Object.fromEntries(
    Object.entries(state.cases || {}).slice(0, 250).map(([id, value = {}]) => [String(id).slice(0, 128), {
      status: String(value.status || 'not-started').toLowerCase(),
      // BL-20: severity only means something on a Fail. A card flipped from
      // Fail back to Pass/Blocked must not export a stale severity.
      severity: String(value.status || '').toLowerCase() === 'fail'
        ? String(value.severity || '').toLowerCase()
        : '',
      notes: String(value.notes || '').slice(0, 4000),
      firstRecordedAt: value.firstRecordedAt || value.timestamp || null,
      feedbackIds: [...new Set((value.feedbackIds || []).slice(0, 50).map((item) => String(item).slice(0, 128)).filter(Boolean))],
      feedbackLinkException: String(value.feedbackLinkException || '').slice(0, 2000),
    }]),
  );
  return {
    schemaVersion: 1,
    acknowledgements: Object.fromEntries(Object.entries(state.acknowledgements || state.checks || {})
      .slice(0, 100).map(([key, value]) => [String(key).slice(0, 128), value === true])),
    generalNotes: String(state.generalNotes || '').slice(0, 10000),
    cases,
  };
}

export function summarizePmGuideState(guideId, inputState) {
  const guideEntry = PM_GUIDE_BY_ID[guideId];
  if (!guideEntry) throw new Error(`Unknown PM guide ${guideId}`);
  const state = normalizePmGuideState(inputState);
  const summary = { total: guideEntry.cardIds.length, completed: 0, pass: 0, fail: 0, blocked: 0, skipped: 0, notStarted: 0 };
  for (const id of guideEntry.cardIds) {
    const status = state.cases[id]?.status || 'not-started';
    if (TERMINAL_STATUSES.has(status)) {
      summary.completed += 1;
      summary[status] += 1;
    } else {
      summary.notStarted += 1;
    }
  }
  return summary;
}

export function validatePmGuideSubmission(guideId, inputState) {
  const guideEntry = PM_GUIDE_BY_ID[guideId];
  if (!guideEntry) return { valid: false, errors: [{ field: 'guideId', message: `Unknown PM guide ${guideId}` }] };
  const state = normalizePmGuideState(inputState);
  const errors = [];
  const unknownIds = Object.keys(state.cases).filter((id) => !guideEntry.cardIds.includes(id));
  if (unknownIds.length) errors.push({ field: 'cases', message: `Unknown test cards: ${unknownIds.join(', ')}` });
  for (const acknowledgementId of guideEntry.acknowledgementIds) {
    if (state.acknowledgements[acknowledgementId] !== true) {
      errors.push({ field: `acknowledgements.${acknowledgementId}`, message: 'Acknowledgement is required' });
    }
  }
  for (const cardId of guideEntry.cardIds) {
    const card = state.cases[cardId] || {};
    if (!TERMINAL_STATUSES.has(card.status)) {
      errors.push({ field: `cases.${cardId}.status`, message: 'Choose Pass, Fail, Blocked, or Skipped' });
      continue;
    }
    if (['fail', 'blocked'].includes(card.status) && !card.notes?.trim()) {
      errors.push({ field: `cases.${cardId}.notes`, message: `${card.status === 'fail' ? 'Fail' : 'Blocked'} requires notes` });
    }
    if (card.status === 'fail') {
      if (!FAIL_SEVERITIES.has(card.severity)) {
        errors.push({ field: `cases.${cardId}.severity`, message: 'Fail requires severity' });
      }
      if (!card.feedbackIds?.length && !card.feedbackLinkException?.trim()) {
        errors.push({ field: `cases.${cardId}.feedbackIds`, message: 'Link Feedback or explain why it could not be filed' });
      }
    }
  }
  return { valid: errors.length === 0, errors, state, summary: summarizePmGuideState(guideId, state) };
}
